
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/volunteering",
      function () {
        return require("private-next-pages/mahashivratri/volunteering/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/volunteering"])
      });
    }
  